import { withForterHeaders } from 'state/graphql/links/with-forter-headers';
import { useFlag } from 'utils/launchdarkly';

import { useForterScriptTag } from './use-forter-script-tag';

export const useForter = () => {
  useForterScriptTag();

  withForterHeaders.setEnabled(useFlag('enable-forter-fraud'));
};
